<template lang="html">
  <div class="location">
    <common-header></common-header>
    <div class="imgContainer">
    	<div><img src="../../../assets/img/aboutUsKv.png" /></div>
    </div>
    <div class="locationContainer">
    	<div class="usTab">地址与联络
    		<img src="../../../assets/img/aboutUsTag.png" />
    	</div>
    	<div class="contentBox">
    		<div class="title">地址与联络方式</div>
    		<div class="eng-title">location & contact</div>
    		<div class="mapContainer" id="dituContent"></div>
    		<div class="contact">
    			<div  class="imgContainer">
    				<img src="../../../assets/img/aboutUs_map.png" />
    			</div>
    			<div class="info">
    				<div class="title">地址</div>
    				<div class="sub-title">上海浦东新区陆家嘴银城中路168号上海银行大厦</div>
    			</div>
    		</div>
    		<div class="contact">
    			<div  class="imgContainer">
    				<img src="../../../assets/img/aboutUs_phone.png" />
    			</div>
    			<div class="info">
    				<div class="title">会员服务热线</div>
    				<div class="sub-title">95521<br/>传真：021-38670666</div>
    			</div>
    		</div>
    		<div class="contact">
    			<div  class="imgContainer">
    				<img src="../../../assets/img/aboutUs_email.png" />
    			</div>
    			<div class="info">
    				<div class="title">Email</div>
    				<div class="sub-title">95521@gtjas.com</div>
    			</div>
    		</div>
    		<div class="qrcorde">
    			<img src="../../../assets/img/vipJh.png" />
    			<div class="info-qr">欢迎关注君弘财富订阅号</div>
    		</div>
    		<div class="qrcorde">
    			<img src="../../../assets/img/gtja.png" />
    			<div class="info-qr">欢迎关注国泰君安订阅号</div>
    		</div>
    	</div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
	import commonHeader from '../../../components/common/commonHeader'
	import commonFooter from '../../../components/common/commonFooter'
	import listKv from '../../../components/common/listKv'
	//接口
	import Server from '../../../server/server.js'
	export default {
	  	data(){
		  	return{
		  		items:[]
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		listKv,
	  	},
	  	methods:{
		    map(){
			    let map =new BMap.Map("dituContent"); // 创建Map实例
			    var point = new BMap.Point(121.468769,31.237246);
			    //设置地图
			    map.enableScrollWheelZoom(true);
			    map.enableDragging();//启用地图拖拽事件，默认启用(可不写)
			    var marker =new BMap.Marker(point);
                map.addOverlay(marker);
			    map.centerAndZoom(new BMap.Point(121.468769,31.237246), 16);// 初始化地图,设置中心点坐标和地图级别
			    // 信息窗的配置信息
	            var opts ={
	                width :100,
	                height:50,
	                title :"我们在这",
	            }
	            var infoWindow =new BMap.InfoWindow("上海市静安区南京西路768号", opts);// 创建信息窗口对象
		        marker.addEventListener("click",function(){
	                map.openInfoWindow(infoWindow,point);
	            },true);
	            map.enableScrollWheelZoom(true);
	            map.openInfoWindow(infoWindow,point);//开启信息窗口
			    map.setCurrentCity("上海");// 设置地图显示的城市 此项是必须设置的

		    }
	 
	    },
		mounted(){
	    	this.map()
		},
		created(){
	  		//
	  	},
	}
	
</script>

<style lang="less" scoped>
	.location{
		.imgContainer{
			padding:0px 40px;
			width:100%;
			margin-top:150px;
			div{
				width:100%;
				border-radius:10px;
				overflow:hidden;
				img{
					width:100%;	
					height:340px;
				}
			}
		}
		.locationContainer{
			width:100%;
			margin-top:30px;
			padding:0 40px;
			.usTab{
				width:100%;
				height:80px;
				padding:0 30px;
				line-height:80px;
				background-image:linear-gradient(90deg, #f1e3bb 0%, #e0c385 100%);
				border-radius:10px;
				text-align:left;
				color:#ad8f5a;
				font-size:28px;
				img{
					width:32px;
					float:right;
					margin-top:24px;
				}
			}
			.contentBox{
				width:100%;
				margin-top:30px;
				text-align:left;
				.title{
					font-size:32px;
					color:#ad8f5a;
					letter-spacing:0;
					line-height:52px;
				}
				.eng-title{
					margin-top:10px;
					font-size:28px;
					color:#818181;
					letter-spacing:0;
					line-height:28px;
				}
				.mapContainer{
					margin-top:30px;
					border-radius:12px;
					width:100%;
					height:300px;
					background:rgba(0,0,0,0.10);
				}
				.contact{
					margin-top:30px;
					border:2px solid rgba(0,0,0,0.10);
					border-radius:8px;
					width:100%;
					display:inline-block;
					.imgContainer{
						float:left;
						margin:30px;
						width:80px;
						height:80px;
						border-radius: 40px;
    					background-color: #f9f9f9;
    					text-align:center;
    					img{
    						width:50px;
    						margin:15px 0;
    						margin-left: -25px;
    						vertical-align: middle;
    					}
					}
					.info{
						margin:30px 0;
						float:left;
						width:525px;
						padding-right:40px;
						text-align:left;
						.title{
							font-size:32px;
							color:#333333;
							letter-spacing:0;
							line-height:64px;
						}
						.sub-title{
							font-size:28px;
							color:#666666;
							letter-spacing:0.09px;
							line-height:52px;
						}
					}
				}
				.qrcorde{
					border:2px solid rgba(0,0,0,0.10);
					border-radius:8px;
					width:100%;
					margin-top:30px;
					text-align:center;
					img{
						vertical-align: middle;
						margin: 40px 0 10px 0;
					}
					.info-qr{
						font-size:28px;
						color:#333333;
						letter-spacing:0;
						line-height:64px;
						width:100%;
						margin-bottom:40px;
					}
				}
				.BMap_bubble_title {color:#CC5522;font-size:14px;font-weight:bold;overflow:hidden;padding-right:13px;white-space:nowrap}
				.BMap_bubble_content {font:12px arial,sans-serif;overflow:visible;padding-top:4px;white-space:-moz-pre-wrap;word-wrap:break-word}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/container/aboutUsPage/aboutUs/location.vue